import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";

import { BlockMediaTextDeprecated } from "@hermes/api-model-editorial";

import { CHAPTERS_PARAGRAPH, SHOULD_PRELOAD_MEDIA } from "../../core";

@Component({
    selector: "h-block-media-text",
    templateUrl: "./block-media-text.component.html",
    styleUrls: ["./block-media-text.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockMediaTextComponent {
    constructor(
        @Inject(CHAPTERS_PARAGRAPH)
        public blockMediaText: BlockMediaTextDeprecated,
        @Inject(SHOULD_PRELOAD_MEDIA) public shouldPreloadMedia: boolean,
    ) {}
}
